{
  "alert": "Ostrzeżenie",
  "dismiss": "Zignoruj"
}